// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Navbar from './components/Navbar';
import Home from './components/Home';
import Skill from './components/Skills';
import Contact from './components/Contact';
import Projects from './components/Projects';
import Footer from './components/Footer';
// import './App.css'





function App() {
  return (
    <div className='App'>
      <Navbar />
      <section id='home'> <Home /></section>
      <section id='about'> <Skill/></section>
      <section id='projects'><Projects/></section>
      <section id='contact'> <Contact/></section>
      <Footer/>
    </div>


  );
}

export default App;
